import React from 'react'
import { IconProps } from './types'

export const Star: React.FC<React.PropsWithChildren<IconProps>> = ({ width, height, className, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className={className}
    width={width}
    height={height}
    aria-label='Star Icon'
  >
    <path fill={fill} d="M114.6 500.8A27.2 27.2 0 0188 467.5l33-145-111.8-98a27.2 27.2 0 0115.4-47.6l147.8-13.4L231 26.7a27.2 27.2 0 0150 0l58.4 136.8 147.8 13.4a27.2 27.2 0 0115.5 47.6l-111.7 98 33 145a27.2 27.2 0 01-40.6 29.4L256 420.8 128.5 497a27.3 27.3 0 01-14 3.8zM256 388c4.8 0 9.6 1.3 14 4l120.2 71.8-31-136.9c-2.3-9.7 1-20 8.6-26.5l105.4-92.5L333.7 195c-10-.9-18.7-7.2-22.6-16.5L256 49.6l-55.2 129a27.1 27.1 0 01-22.5 16.5L38.7 207.7l105.5 92.5a27.2 27.2 0 018.6 26.6l-31 137 120.2-72c4.3-2.6 9.1-3.9 14-3.9zm-84.6-221.8zm169.1 0zm0 0" />
  </svg>
)

export const StarFilled: React.FC<React.PropsWithChildren<IconProps>> = ({ width, height, className, fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    className={className}
    width={width}
    height={height}
    aria-label='Star Filled Icon'
  >
    <path fill={fill} d="M114.4 500.7c-5.6 0-11.2-1.7-15.9-5.2-8.8-6.4-13-17.4-10.6-28l32.9-144.8L9.3 224.9c-8.2-7.2-11.3-18.5-8-28.9 3.4-10.3 12.5-17.7 23.4-18.7L172.2 164l58.3-136.5c4.3-10 14.1-16.5 25-16.5s20.7 6.5 25 16.5L338.8 164l147.5 13.4c10.9 1 20 8.3 23.4 18.7 3.4 10.3.3 21.7-7.9 28.9l-111.5 97.8 32.9 144.8c2.4 10.6-1.7 21.7-10.6 28-8.8 6.4-20.6 6.9-29.9 1.3l-127.2-76L128.3 497c-4.3 2.4-9.1 3.7-13.9 3.7zm56.7-334.1zm168.8-.1z" />
  </svg>
)
